import * as React from 'react';
import UnitOptions from 'src/container/Unit/UnitOptions';
import UnitGroupOptions from 'src/container/UnitGroup/UnitGroupOptions';
import { ListInput, BaseComponentClass, BasicCompoClassProps } from '../generic/ListInput';
import { Form } from 'semantic-ui-react';
import { inject, observer } from 'mobx-react';
import { FilterInput as FilterInputInterface } from 'src/services/graphql/Models';

interface FilterInputProps {
    onChange: (e: Event, data: {name: string, value: string}) => any;
    name: string;
    initialValue: any;
}

@inject('authStore')
@observer
class FilterInput extends BaseComponentClass {
    unitSensorChangeHandler(e: any, d: any) {
        d.value = d.value.split(',');
        this.changeHandler(e, d);
    }

    render() {
        const { 
            unitGroups,
            unitIds,
            unitSensors
        } = this.state;

        return (
            <div>
                <Form.Field>  
                    <label>Unit Groups</label>
                    <UnitGroupOptions
                        multiple
                        onChange={this.changeHandler}
                        name="unitGroups"
                        defaultValue={unitGroups} 
                    />
                </Form.Field>
                <Form.Field>
                    <label>Unit</label>
                    <UnitOptions
                        multiple
                        placeholder="Units" 
                        name="unitIds"
                        defaultValue={unitIds}
                        onChange={this.changeHandler}
                    />
                </Form.Field>
                <Form.Field>  
                    <label>Unit Sensor</label>
                    <Form.Input
                        onChange={this.unitSensorChangeHandler.bind(this)}
                        name={'unitSensors'}
                        defaultValue={unitSensors.join(',')}
                    />
                </Form.Field> 
            </div>
        );
    }
}

export default class FilterInputs extends React.Component<FilterInputProps> {
    itemRenderer = this.toTrigger.bind(this);

    validate(_value: FilterInputInterface): boolean | any {
        return true;
    }

    handleValuesChange(values: any) {
        this.props.onChange({} as any, { name: this.props.name, value: values});
    }

    toTrigger(props: BasicCompoClassProps) {
        return (
            <FilterInput 
                {...props}
            />
        );
    }

    render() {
        return (
            <ListInput
                initialValues={this.props.initialValue}
                defaultValue={() => {
                    return  {
                        unitIds: [],
                        unitGroups: [],
                        unitSensors: [],
                    };
                }}
                name={this.props.name}
                onValuesChange={this.handleValuesChange.bind(this)}
                validate={this.validate.bind(this)}
                Item={this.itemRenderer}
                StagingItem={this.itemRenderer}
                addButtonText="Add Filter"
            />
        );
    }

}


// WEBPACK FOOTER //
// ./src/components/inputs/FilterInput.tsx